module.exports = __webpack_public_path__ + "img/parks-3-5.8e065a7d.jpg";